import { I as Icon, _ as _extends } from './Icon-465858dc.js';
import React, { forwardRef } from 'react';
import '@emotion/is-prop-valid';
import '@indeed/ifl-css';
import '@emotion/react';
import './IconProvider.js';

const Instagram = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    fill = "currentColor",
    size = "md",
    variant,
    ...remainingProps
  } = _ref;
  const paths = {
    filled: /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      d: "M16.5 3h-9C5.0188 3 3 5.0188 3 7.5v9C3 18.9812 5.0188 21 7.5 21h9c2.4812 0 4.5-2.0188 4.5-4.5v-9C21 5.0188 18.9812 3 16.5 3zM12 17.4677c2.6832 0 4.8584-2.1465 4.8584-4.7944 0-2.6479-2.1752-4.7944-4.8584-4.7944s-4.8584 2.1465-4.8584 4.7944c0 2.6479 2.1752 4.7944 4.8584 4.7944zm4.2217-10.9344c0-.7415.6079-1.3458 1.354-1.3458.746 0 1.3539.6043 1.3539 1.3458 0 .7415-.6079 1.3458-1.3539 1.3458-.7461 0-1.354-.6043-1.354-1.3458z",
      clipRule: "evenodd"
    }),
    stroke: /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      d: "M16.5 3h-9C5.0188 3 3 5.0188 3 7.5v9C3 18.9812 5.0188 21 7.5 21h9c2.4812 0 4.5-2.0188 4.5-4.5v-9C21 5.0188 18.9812 3 16.5 3zM12 17.4677c2.6832 0 4.8584-2.1465 4.8584-4.7944 0-2.6479-2.1752-4.7944-4.8584-4.7944s-4.8584 2.1465-4.8584 4.7944c0 2.6479 2.1752 4.7944 4.8584 4.7944zm4.2217-10.9344c0-.7415.6079-1.3458 1.354-1.3458.746 0 1.3539.6043 1.3539 1.3458 0 .7415-.6079 1.3458-1.3539 1.3458-.7461 0-1.354-.6043-1.354-1.3458z",
      clipRule: "evenodd"
    })
  };
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref,
    fill: fill,
    paths: paths,
    size: size,
    variant: variant
  }, remainingProps));
});
Instagram.displayName = "InstagramIcon";

export { Instagram, Instagram as default };
